<template>
  <div>
    <v-btn class="hidden-sm-and-down" color="primary" rounded @click="open()"
      >New Agency</v-btn
    >
    <v-btn
      class="mx-2 hidden-sm-and-up"
      fab
      dark
      small
      color="primary"
      @click="open()"
    >
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>
    <v-navigation-drawer
      app
      temporary
      right
      disable-resize-watcher
      width="650px"
      v-model="show"
      class="actionDrawer"
    >
      <v-row class="mx-4 mt-4" justify="center" align="center">
        <v-col cols="2">
          <v-btn @click="cancelOperation()" color="primary" icon>
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="8" class="text-center">
          <v-img
            src="../../assets/Compeat-logo.jpg"
            width="280px"
            class="mx-auto"
          />
        </v-col>
        <v-col cols="2"> </v-col>
      </v-row>
      <v-row class="mx-4">
        <v-col cols="12">
          <v-overlay v-if="overlay" :absolute="absolute" :value="overlay">
            <v-card class="secondary px-4 py-4">
              <v-row>
                <v-col class="col-12 black--text text-center">
                  <v-icon size="50" color="primary">mdi-alert-circle</v-icon>
                  <p class="body-1 py-3">
                    Opps something went wrong, please try again.
                  </p>
                  <v-btn icon color="primary" @click="cancelError()">
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-overlay>
          <v-card flat>
            <v-form v-if="!addPaymentMethod" ref="form" v-model="valid">
              <v-card-text>
                <div class="px-4 py-4">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <h1 class="danetest--text">New Agency Details</h1>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        v-model="agencyName"
                        label="Agency Name"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="firstName"
                        label="Contact Person First Name"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col ols="6">
                      <v-text-field
                        v-model="lastName"
                        label="Contact Person Last Name"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="mobile"
                        label="Contact Person Mobile (+27)"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        v-model="emailAddress"
                        label="Contact Person Email Address"
                        :rules="emailRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="agencyType"
                        :items="agencyTypes"
                        label="Select Agency Type"
                        item-text="name"
                        item-value="value"
                        @change="handleSelect"
                        class="selectpackage"
                        :rules="[rules.required]"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input
                        chips
                        color="danetest"
                        label="Choose logo to upload"
                        accept=".jpeg"
                        @change="getFileObject1($event)"
                        :rules="[rules.required]"
                        clearable
                      ></v-file-input>
                    </v-col>
                    <!-- <v-col cols="12">
                  <v-file-input
                    chips
                    color="danetest"
                    label="Choose onboarding form to upload"
                    accept=".pdf"
                    @change="getFileObject($event)"
                    :rules="[rules.required]"
                    clearable
                  ></v-file-input>
                </v-col> -->
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="text-center">
                      <v-btn
                        rounded
                        @click="cancelOperation()"
                        class="primary white--text"
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                    <v-col cols="6" class="text-center">
                      <v-btn
                        :loading="loading"
                        class="primary white--text"
                        rounded
                        :disabled="!valid"
                        @click="writeFilesToStorage()"
                      >
                        Submit
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { firebaseApp } from "../../firebaseConfig";
import { setDoc, getFirestore, doc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import ShortUniqueId from "short-unique-id";
const storage = getStorage(firebaseApp);
const db = getFirestore(firebaseApp);

export default {
  props: ["eventname"],
  data: () => ({
    overlay: false,
    absolute: true,
    show: false,
    dialog: false,
    successResponse: "",
    errorMessage: false,
    loading: false,
    agencyName: "",
    firstName: "",
    lastName: "",
    mobile: "",
    emailAddress: "",
    fileOnboarding: "",
    fileLogo: "",
    file: [],
    file2: [],
    valid: false,
    rules: { required: (value) => !!value || "Required." },
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    supervisorPinRules: [
      (v) => !!v || "supervisorPinRules",
      (v) =>
        (v && v.length <= 5) || "Supervisor Pin must be less than 5 Numbers",
    ],
    addPaymentMethod: false,
    agencyTypes: [
      { name: "CompEatBeta", value: "CompEatBeta" },
      { name: "CompEatPaid", value: "CompEatPaid" },
    ],
    agencyType: "",
  }),
  methods: {
    handleSelect(value) {
      this.agencyType = value;
    },
    async writeFilesToStorage() {
      this.loading = true;
      var formUid = new ShortUniqueId({ length: 20 });
      var vuid = formUid();

      const onbordingLogo = ref(
        storage,
        "agencylogos/" + vuid + "/" + this.fileLogo
      );
      //const onbordingRef = ref(storage, 'agencyonboarding/' + vuid + '/' + this.fileOnboarding);

      let imageUrl = "";
      // let onboardingUrl = ''

      try {
        await Promise.all([
          uploadBytes(onbordingLogo, this.file).then((snapshot) => {
            return getDownloadURL(snapshot.ref);
          }),
          // uploadBytes(onbordingRef, this.file2).then((snapshot) => {
          //     return getDownloadURL(snapshot.ref);
          // })
        ]).then(([logoUrl]) => {
          imageUrl = logoUrl;
          // onboardingUrl = onboardingDocUrl;
        });
      } catch (error) {
        console.log("Error uploading or getting download URLs:", error);
      }

      this.createAgencyProfile(imageUrl, vuid);
    },

    async getFileObject1(files) {
      this.file = await files;
      this.fileLogo = this.file.name;
    },

    async getFileObject(files) {
      this.file2 = await files;
      this.fileOnboarding = this.file2.name;
    },

    async createAgencyProfile(onbordingLogo, uid) {
      try {
        await setDoc(doc(db, "agencies", uid), {
          agencyId: uid,
          agencyName: this.agencyName,
          agencyContactPersonName: this.firstName + " " + this.lastName,
          agencyContactPersonMobile: this.mobile,
          agencyContactPersonEmail: this.emailAddress,
          agencyLogo: onbordingLogo,
          agencyType: this.agencyType,
          dateCreate: Date.now(),
          isActive: true,
        });

        this.loading = false;
          let alertType = "success";
          this.successResponse = "Agency Created Successfully";
          this.loading = false;
          this.show = false;
          this.$emit("eventname", this.successResponse, alertType);

      } catch (e) {
        this.errorMessage = true;
        this.overlay = true;
        this.loading = false;
      }
    },

    cancelError() {
      this.overlay = false;
    },

    cancelOperation() {
      this.$refs.form.reset();
      this.show = false;
    },

    validate() {
      this.$refs.form.validate();
    },

    validate() {
      this.$refs.paymentForm.validate();
    },

    //open New Subscribtion Drawer and display over Layer
    open() {
      this.show = !this.show;
    },
  },
};
</script>

<style>
h6 {
  font-size: 30px;
}
</style>
